import React from 'react';
export function Footer() {
  return <footer className="bg-forest-dark py-6 px-5 text-center text-[0.78rem] text-cream/45" data-id="element-128">
      © 2024 Programa de Activación Lectora. Todos los derechos reservados.
    </footer>;
}